import { withTheme } from '@rjsf/core';
import { Theme as AntDTheme } from '@rjsf/antd';
import validator from '@rjsf/validator-ajv8';
import React, { useState } from 'react';

import schemaData from '../response.json';

const Form = withTheme(AntDTheme);

export const ShopDetailsEditContainer = () => {
    const [formData, setFormData] = useState();

    return (
        <Form
            schema={schemaData}
            validator={validator}
            formData={formData}
            onChange={e => setFormData(e.formData)}
            uiSchema={{}}
        />
    );
};
